var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3098 10.3366L10.8098 2.8366C10.5098 2.5366 10.0931 2.35327 9.63476 2.35327H3.80143C2.88477 2.35327 2.13477 3.10327 2.13477 4.01994V9.85327C2.13477 10.3116 2.3181 10.7283 2.62643 11.0366L10.1264 18.5366C10.4264 18.8366 10.8431 19.0199 11.3014 19.0199C11.7598 19.0199 12.1764 18.8366 12.4764 18.5283L18.3098 12.6949C18.6181 12.3949 18.8014 11.9783 18.8014 11.5199C18.8014 11.0616 18.6098 10.6366 18.3098 10.3366ZM11.3014 17.3616L3.80143 9.85327V4.01994H9.63476V4.0116L17.1348 11.5116L11.3014 17.3616Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88477 7.35327C6.57512 7.35327 7.13477 6.79363 7.13477 6.10327C7.13477 5.41292 6.57512 4.85327 5.88477 4.85327C5.19441 4.85327 4.63477 5.41292 4.63477 6.10327C4.63477 6.79363 5.19441 7.35327 5.88477 7.35327Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.e7c753350a24e29307932fba6631275d.svg";
export { ForwardRef as ReactComponent };